type Props = {
    aiScore: number;
    value: number | null;
    onChange: (score: number) => void;
    overrideEnabled: boolean;
    onToggleOverride: () => void;
};

function ScoreAdjustmentRow({
    aiScore,
    value,
    onChange,
    overrideEnabled,
    onToggleOverride,
}: Props) {
    const inRange = (n: number) => Math.abs(n - aiScore) <= 1;

    return (
        <div className="score-adjustment">
            <div className="score-adjustment__header">
                <h3>Final score</h3>
                <span className="score-adjustment__hint">AI: {aiScore}/5</span>
            </div>
            <div className="score-adjustment__buttons" role="group" aria-label="Final score">
                {[0, 1, 2, 3, 4, 5].map((n) => {
                    const allowed = inRange(n) || overrideEnabled;
                    const isSelected = value === n;
                    return (
                        <button
                            key={n}
                            type="button"
                            className={`score-adjustment__btn ${isSelected ? 'is-selected' : ''}`}
                            onClick={() => allowed && onChange(n)}
                            disabled={!allowed}
                            aria-pressed={isSelected ? 'true' : 'false'}
                        >
                            {n}
                        </button>
                    );
                })}
            </div>
            <button
                type="button"
                className="score-adjustment__override-link"
                onClick={onToggleOverride}
            >
                {overrideEnabled ? 'Cancel override' : 'Need to score outside AI ±1?'}
            </button>
        </div>
    );
}

export default ScoreAdjustmentRow;
